import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

class NavLink extends React.Component {
    constructor(props) {
        super(props);
        this.active = false;
        this.onActive = this.props.onActive;
    }

    isLocationMatching = (to) => {
        return `${to}` === location.pathname || `${to}/` === location.pathname;
    };

    update = () => {
        const { onActive, to } = this.props;
        if (onActive && this.isLocationMatching(to)) {
            onActive();
        }
    };

    componentDidMount() {
        this.update();
    }

    componentDidUpdate() {
        this.update();
    }

    shouldComponentUpdate() {
        const { to } = this.props;
        return !this.active || !this.isLocationMatching(to);
    }

    render() {
        var { to, ...other } = this.props;

        // Find these classes in the index.css style override file.
        // var classes = 'navlink';
        var classes = 'navlink';
        if (location.pathname.includes(to)) {
            classes += ' active';
            this.active = true;
        } else {
            this.active = false;
        }

        const createLink = (path, rel) => {
            if (rel === '#') return path;
            if (rel[0] !== '/') return path + rel;
            return rel;
        };
        return (
            <Link
                className={classes}
                to={createLink(location.pathname, to)}
                onClick={(e) => {
                    if (to === '#') {
                        e.preventDefault();
                    } else {
                        this.props.onClick();
                    }
                }}
                {...other}
            >
                {this.props.children}
            </Link>
        );
    }
}

NavLink.propTypes = {
    router: PropTypes.object,
    onActive: PropTypes.func,
    to: PropTypes.string.isRequired,
    children: PropTypes.object,
};

export default NavLink;
